<template>
  <div>
    <div style="display: flex; flex-direction: column;">
      <vs-progress
        v-show="showProgress"
        indeterminate
        color="primary"
      ></vs-progress>

      <div>{{ !isCrop ? '画像ファイル選択' : '画像トリミング' }}</div>
      <div
        v-if="!imgSrc"
        :class="[isDrag ? dragoverClass : dragleaveClass]"
        @dragover.prevent="checkDrag($event, true)"
        @dragleave.prevent="checkDrag($event, false)"
        @drop.prevent="setImage($event)"
        @click="$refs.update_photo_input.click()"
      >
        <input
          type="file"
          ref="update_photo_input"
          class="hidden"
          @change="setImage($event)"
        />
        <vs-icon icon="system_update_alt" size="25px" />
        <span
          >画像ファイルをドロップ、<br />またはクリックしてファイルを選択<br /><br />
            <small
              >フォーマット: PNG、JPG、JPEG、GIF<br />最大アップロードサイズ:
              5MB</small
            ></span
        >
        <span class="text-danger text-sm" v-show="error.message">{{
          error.message
        }}</span>
      </div>
      
      <div v-if="isCrop">
        <div class="flex w-full h-full justify-center">
          <vue-cropper
            ref="cropper"
            :src="imgSrc"
            v-show="showCrop"
            :autoCropArea="0.8"
            :dragMode="'move'"
            :restore="false"
            :guides="false"
            :center="false"
            :highlight="false"
            :background="false"
            :cropBoxMovable="false"
            :cropBoxResizable="false"
            :aspectRatio="1 / 1"
            :toggleDragModeOnDblclick="false"
            style="max-height: 180px;"
          ></vue-cropper>
        </div>
      </div>

      <div class="flex w-full justify-end">
        <vs-button
          @click="cancel"
          :color="AISEA_COLOR.WHITE"
          :style="{ 'color': AISEA_COLOR.GRAY }"
          style="width: 6rem; margin: 0.2rem; padding: 0.2rem 0.4rem;"
          type="filled"
          >キャンセル</vs-button
        >
        <vs-button
          @click="save"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          style="width: 6rem; margin: 0.2rem; padding: 0.2rem 0.4rem;"
          :disabled="!isCrop"
          >保存</vs-button
        >
      </div>

    </div>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { FileUtil } from "@/utils";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
// const picApi = AiseaApiFactory.get("picture");
const picApi = AiseaApiFactory.get("enterpriseCrewPicture");

export default {
  components: { VueCropper },
  props: {
    enterpriseCrewId: { type: String, required: true },
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      showDialog: false,
      title: "プロフィール画像の変更",
      error: { message: null },
      acceptText: "保存",
      cancelText: "キャンセル",
      isValid: false,
      showProgress: false,
      pictureData: {},
      pictureUrl: null,
      imgSrc: null,
      fileType: null,
      cropImg: null,
      isDrag: false,
      isCrop: null,
      showCrop: false,
      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover",
    };
  },
  methods: {
    show() {
      this.showDialog = true;
      this.title = "プロフィール画像の選択";
    },
    async save() {
      this.showCrop = false;
      let base64 = this.$refs.cropper.getCroppedCanvas().toDataURL();
      await this.uploadImage(FileUtil.toBlob(base64, this.fileType));
      this.$nextTick(() => {
        this.isCrop = false;
      }); 
    },
    close() {
      this.cleanUp();
    },
    cancel() {
      this.cleanUp();
      if ( ! this.isCrop ) {
        this.$emit('onImageUploadCancel');
      }
    },
    checkDrag(e, isDrag) {
      this.isDrag = isDrag;
    },
    setImage(e) {
      this.title = "プロフィール画像のトリミング";
      const file =
        typeof e.target.files !== "undefined"
          ? e.target.files[0]
          : e.dataTransfer.files[0];

      if (!this.validateInputFile(file)) {
        return;
      }
      this.fileType = file.type
      let reader = new FileReader();
      reader.onload = e => {
        this.imgSrc = e.target.result;
        this.isValid = true;
        this.isCrop = true;
        this.showCrop = true;
      };
      reader.readAsDataURL(file);
    },
    validateInputFile(file) {
      if ( !file.type
        || !file.type.match("image/png") 
        && !file.type.match("image/jpeg")
        && !file.type.match("image/jpg")
        && !file.type.match("image/gif")
      ) {
        this.error.message = "指定フォーマットの画像ファイル以外は選択できません";
        return false;
      }
      this.fileSIze = file.size;
      if (this.fileSIze >= 5000000) {
        this.error.message = "サイズは5メガバイト以下にしてください";
        return false;
      }
      this.error.message = null;
      return true;
    },
    async uploadImage(inputFile) {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
      let formData = new FormData();
      formData.append("data", inputFile);
      try {
        // let response = await picApi.addUserPicture({ formData: formData }); // TODO: あとで変える必要があるか確認
        let response = await picApi.addPicture(this.enterpriseCrewId, { formData: formData }); // TODO: あとで変える必要があるか確認
        this.pictureData = response.data;
        this.getPictureUrl();
      }catch (e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "プロフィール画像の登録に失敗しました",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.close()
      }
    },
    getPictureUrl() {
      storage
        .child(this.pictureData.original_path)
        .getDownloadURL()
        .then(response => {
          this.pictureUrl = response;
          setTimeout(() => {
            this.onImageUpdated();
          }, 2000);
        })
        .catch(error => {
          //FireStoreにサムネイルができるまでリトライ
          if (error.code === "storage/object-not-found") {
            setTimeout(() => {
              this.getPictureUrl(this.pictureData.original_path);
            }, 3000);
          }
        });
    },
    onImageUpdated() {
      this.$emit("onImageUploaded", {
        data: this.pictureData,
        url: this.pictureUrl
      });
      this.$vs.loading.close()
      this.cleanUp();
    },
    cleanUp() {
      this.showDialog = false;
      this.showProgress = false;
      this.showCrop = false;
      this.imgSrc = null;
      this.isDrag = false;
      this.title = "プロフィール画像の選択";
      this.error.message = "";
      if (this.$refs.update_photo_input) {
        this.$refs.update_photo_input.value = null;
      }

      setTimeout(() => {
        this.isCrop = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
.drag-area-dragleave {
  width: 100%;
  min-width: 200px;
  height: 100%;
  min-height: 200px;
  border: 2px dotted rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  text-align: center;
}

.drag-area-dragover {
  width: 100%;
  min-width: 200px;
  height: 100%;
  min-height: 200px;
  border: 2px solid rgba(115, 103, 240, 1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f5f5f5;
  text-align: center;
}

.con-vs-dialog {
  //プレビューのとき重なりの順序を変更するためz-indexを指定
  z-index: 60000;
}

.cropper-view-box {
  border-radius: 50%;
  cursor: grab;
  outline: initial;
}

</style>
